<template>
  <div>
    <ButtonView type="shaded" color="foreground" size="small" :active="active || editor.isActive('link')" @click="editor.chain().focus().extendMarkRange('link').run(); active = true">
      <i class="fas fa-link fa-fw" style="font-size: 1.2em"></i>
    </ButtonView>
    <ModalView v-model:active="active">
      <template v-slot:body>
        <LinkFormView :editor="editor" @submit="active = false"/>
      </template>
    </ModalView>
  </div>
</template>

<script setup>
import ButtonView from "../../../general/ButtonView.vue";
import {ref} from "vue";
import LinkFormView from "./LinkFormView.vue";
import ModalView from "../../../../plugins/modal/ModalView.vue";

const props = defineProps({
  editor: Object
});

const active = ref(false);

</script>